<template>
<div class="Header">
  <div class="Wrapper">
    <div class="Logo">
      <router-link to="/" title="friDay x 美安大會" class="Logo">friDay x 美安大會</router-link>
    </div>
    <div id="topMenu">
      <ul>
        <!-- <li><a href="https://shopping.friday.tw/ec2/GroupurchaseAddForm" target="_blank">企業團體採購</a></li>
        <li> | </li> -->
        <li><a href="#" @click.prevent="formShow = !formShow">我要許願</a></li>
      </ul>
    </div>
  </div>
  <wishForm
    v-if="formShow"
    @closeBuyItem="formShow = false"
    @alertTips="alertTips" />
  <alert
    v-if="showAlert"
    v-on:closeAlertTips="closeAlertTips"
    :message="showAlertMsg" />
</div>
</template>

<script>
import wishForm from "./wishForm.vue";
import alert from "./alert.vue";
export default {
  name: "headerComponent",
  data() {
    return {
      showOverlay: true,
      formShow: false,
      showAlert: false,
      showAlertMsg: "",
    }
  },
  methods: {
    alertTips(message) {
      this.showAlertMsg = message;
      this.showAlert = true;
    },
    closeAlertTips() {
      this.showAlert = false;
    },
  },
  components: {
    wishForm,
    alert
  }
};
</script>

<style lang="scss" scoped>
.Header {
  height: 52px;
  background-color: #fff;

  @media(max-width:768px) {
    height: 45px;
    overflow: hidden;
  }

  #topMenu {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);

    ul {
      li {
        display: inline-block;
        margin-right: 20px;
        font-size: .875rem;

        @media(max-width:768px) {
          margin-right: 10px;
        }
      }
    }
  }

  .Logo {
    padding: 1% 0 0 1%;
    display: block;

    @media(max-width:768px) {
      padding: 0;
    }

    a {
      background: url(../../assets/friday@2x.png) no-repeat;
      width: 146px;
      height: 32px;
      background-size: 100%;
      text-indent: -9999px;

      @media(max-width:768px) {
        width: 110px;
        height: 24px;
        margin: 13px auto 15px 8px;
      }
    }
  }
}
</style>
